// extracted by mini-css-extract-plugin
export default {"mainContainer":"tableView_mainContainer__K95Qx"};